import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', _ => {
    document.querySelectorAll('.event-carousel').forEach(carousel => {
        const slider = new Swiper(carousel, {
            modules: [Scrollbar],
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            initialSlide: 0,
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 26,
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                1400: {
                    slidesPerView: 5,
                },
            },
        });
    });
});